import URL from '@/common/app/utils/urlsUtils';

export const DESTINATIONS_LIST = [
    { name: 'Destin', href: '/destination/fl/destin/things-to-do/', subtitle: 'FL' },
    { name: 'New Orleans', href: '/destination/la/new-orleans/things-to-do/', subtitle: 'LA' },
    {
        name: 'Gulf Shores',
        href: '/destination/al/gulf-shores-orange-beach/things-to-do/',
        subtitle: 'AL',
    },
    { name: 'View All Destinations', href: '/destination/' },
];

export const SUPPORT_LIST = [
    { name: 'Get Help', href: '/customer-service-guide/' },
    { name: 'Privacy Policy', href: '/policy/' },
    { name: 'GDPR', href: '/policy#gdpr' },
    { name: 'Terms of Use', href: '/terms/' },
    { name: 'Fishing Guide', href: '/official-fishing-guide/' },
    { name: 'Site Map', href: '/site-navigation/' },
];

export const WORK_WITH_US_LIST = [
    { name: 'Tour Operators', href: `${URL.partners}/activity-operators/` },
    { name: 'Affiliates', href: `${URL.partners}/affiliates/` },
    { name: 'Partner Solutions', href: `${URL.partners}/partner-solutions/` },
    { name: 'Business Development', href: `${URL.partners}/connect-with-us/` },
];

export const COMPANY_LIST = [
    { name: 'About Us', href: `${URL.partners}/about-us/` },
    { name: 'Partners', href: '/partners/' },
    { name: 'Blog', href: '/blog/' },
    { name: 'Careers', href: `${URL.partners}/careers/` },
    { name: 'Gift Cards', href: '/TripShock-com-Gift-Card/details/1025/' },
    { name: 'Landmarks', href: '/landmarks/' },
];
